import { Component, Inject, TemplateRef, Type } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface DialogWrapperData {
  // An i18n key.
  title: string;
  // Shown as-is instead of translating `title`, for names that aren't i18n keys (e.g. a team
  // the user named). Opt-in; callers that only set `title` are unaffected.
  rawTitle?: string;
  /** Optional i18n interpolation value for `title` (passed as the pipe's p1 arg), e.g. an
   * account name for a "Share __$1__" title. */
  titleParam?: string;
  component: Type<any>;
  componentInputs: Record<string, unknown>;
  onBackClicked?: () => void;
  showBackButton: boolean;
  showCloseButton?: boolean;
  isInfoDialog?: boolean;
  fullyCustomised?: boolean;
  isFooter?: boolean;
  footerTemplate?: TemplateRef<any>;
  customizedCloseIcon?: string;
  useLargeRoundedCorners?: boolean;
  plainCloseButton?: boolean;
  /** Opt-in CSS `background` for the dialog's root surface (e.g. a decorative gradient on a
   *  receipt/success screen). Left unset, callers keep the plain `tw-bg-color-surface-card`. */
  bodyBackground?: string;
}

@Component({
  selector: "app-dialog-wrapper",
  templateUrl: "./dialog-wrapper.component.html",
})
export class DialogWrapperComponent {
  protected showCloseButton: boolean = this.data.showCloseButton ?? true;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: DialogWrapperData,
  ) {}

  get componentInputs() {
    return this.data.componentInputs ?? {};
  }

  footerTemplate() {
    return this.data.footerTemplate;
  }

  getComponent() {
    return this.data.component;
  }

  handleBackClicked() {
    this.data.onBackClicked();
  }
}
